import * as React from "react"
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card"

interface ArrayFieldCellProps {
  count: number
  noun: string
  isDefault?: boolean
  hoverContent: React.ReactNode
  editor: React.ReactNode
}

export function ArrayFieldCell({
  count,
  noun,
  isDefault = false,
  hoverContent,
  editor,
}: ArrayFieldCellProps) {
  const label = count === 1 ? noun : `${noun}s`

  return (
    <div
      className="font-medium text-foreground flex items-center gap-2"
      onClick={(e) => e.stopPropagation()}
    >
      <HoverCard openDelay={200} closeDelay={100}>
        <HoverCardTrigger asChild>
          <span className="inline-flex items-center rounded-md border border-input bg-muted/40 px-2 py-1 text-xs text-muted-foreground cursor-default">
            {count} {label}
          </span>
        </HoverCardTrigger>
        <HoverCardContent className="w-72 bg-popover border-border" align="start">
          {hoverContent}
        </HoverCardContent>
      </HoverCard>
      {editor}
      {isDefault && <span className="text-xs text-muted-foreground">(default)</span>}
    </div>
  )
}

export function ArrayHoverList({ items }: { items: string[] }) {
  if (items.length === 0) {
    return <p className="text-xs text-muted-foreground">No items configured.</p>
  }
  return (
    <ul className="space-y-1">
      {items.map((item, index) => (
        <li key={`${item}-${index}`} className="text-xs text-foreground truncate">
          {item}
        </li>
      ))}
    </ul>
  )
}
